<template>
    <div class="">
        <div class="mb-8 space-y-2 max-w-7xl mx-auto">
            <div class="flex items-center justify-between bg-gray-50 py-2 px-3">
                <h4 class="text-lg text-center font-medium">{{ $t('Givs') }}</h4>
                <div class="flex justify-end">
                    <button
                        class="bg-blue-500 text-white border border-blue-500 hover:border-blue-600 hover:bg-white hover:text-blue-800 transition duration-150 text-sm rounded px-3 py-2"
                        @click="open = true"
                    >
                        {{ $t('Register Giv') }}
                    </button>
                </div>
            </div>
            <form class="py-2 grid grid-cols-2">
                <div>
                    <label for="name" class="hidden">{{ $t('Search') }}</label>
                    <v-select
                        class="flex-1 style-select"
                        @search="search"
                        placeholder="Filter by member"
                        :options="filterMemberList"
                        @input="setSelected"
                        clearable
                    >
                        <template v-slot:option="option">
                            <div
                                class="w-full py-3 flex items-center space-x-3 focus:outline-none overflow-x-hidden"
                            >
                                <div
                                    class="flex-shrink-0 w-12 sm:w-20 h-12 sm:h-20 rounded border-2 border-gray-200 overflow-hidden"
                                >
                                    <img
                                        loading="lazy"
                                        alt="option.name"
                                        width="100%"
                                        height="100%"
                                        class="object-cover"
                                        :src="parseUrl(option.photoURL)"
                                    />
                                </div>
                                <div class="flex-1 truncate">
                                    <div class="flex items-center space-x-4">
                                        <h3 class="text-sm sm:text-lg font-medium ml-2">
                                            {{ option.name }}
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </v-select>
                </div>
            </form>

            <modal :closable="true" @close="closeModal" title="Register Giv" :open="open">
                <div slot="content">
                    <span
                        class="my-12 flex items-center justify-center w-full border border-transparent bg-green-400 font-medium text-sm text-white px-4 py-3 rounded focus:outline-none focus:shadow-outline"
                        v-if="submitted"
                    >
                        <svg
                            class="w-5 h-5 text-white mr-1"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                        </svg>
                        {{ $t('Submitted') }}</span
                    >
                    <form
                        v-else
                        class="md:pt-6 md:pb-10 space-y-2 md:space-y-4"
                        @submit.prevent="createGiv"
                    >
                        <div class="md:flex items-center space-y-2 md:space-y-0">
                            <section class="flex-1 space-y-1 flex flex-col">
                                <label for="givGiver" class="text-sm">{{ $t('Giver') }}</label>
                                <v-select
                                    :disabled="submitting || submitted"
                                    class="style-select"
                                    @search="searchGivers"
                                    v-model="formGivGiver"
                                    placeholder="Select Giver User"
                                    :options="searchGiversList"
                                />
                            </section>
                            <svg
                                class="hidden md:block w-6 h-6 mx-4 text-gray-300"
                                fill="none"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                            </svg>
                            <section class="flex-1 space-y-1 flex flex-col">
                                <label for="givReceiver" class="text-sm">{{
                                    $t('Receiver')
                                }}</label>
                                <v-select
                                    :disabled="submitting || submitted"
                                    class="style-select"
                                    @search="searchReceivers"
                                    v-model="formGivReceiver"
                                    placeholder="Select Receiver User"
                                    :options="searchReceiversList"
                                />
                            </section>
                        </div>
                        <div class="flex items-center space-x-3">
                            <section class="flex-1 space-y-1 flex flex-col">
                                <label for="givKind" class="text-sm">{{ $t('Giv Type') }}</label>
                                <select
                                    :disabled="submitting || submitted"
                                    v-model="formGivType"
                                    name="givKind"
                                    class="form-select"
                                >
                                    <option :label="$t('Meetup')">meetup</option>
                                    <option :label="$t('Mail')">mail</option>
                                </select>
                            </section>
                            <section class="flex-1 space-y-1 flex flex-col">
                                <label for="givDate" class="text-sm">{{ $t('Date') }}</label>
                                <input
                                    :disabled="submitting || submitted"
                                    v-model="formGivDate"
                                    name="givDate"
                                    type="date"
                                    class="form-input"
                                />
                            </section>
                        </div>
                        <section class="space-y-1 flex flex-col">
                            <span
                                v-if="formError"
                                class="bg-red-100 text-center text-sm py-1 px-1 rounded shake text-red-900 max-w-3xl overflow-auto"
                            >
                                {{ this.formError }}
                            </span>
                        </section>
                        <div>
                            <button
                                class="flex items-center justify-center w-full border border-transparent hover:bg-transparent hover:border-blue-500 hover:text-gray-900 transition duration-150 font-medium text-sm text-white px-4 py-3 rounded focus:outline-none focus:shadow-outline"
                                :class="[
                                    submitting || !this.formValid
                                        ? 'pointer-events-none bg-gray-200'
                                        : 'bg-blue-500',
                                ]"
                                type="submit"
                            >
                                <spinner v-if="submitting" class="text-white" />
                                <span v-else>{{ $t('Register Giv') }}</span>
                            </button>
                        </div>
                    </form>
                </div>
            </modal>
            <ul class="space-y-1">
                <li v-for="giv in givs" :key="giv.id">
                    <GivCard :giv="giv" />
                </li>
            </ul>

            <spinner v-if="!givs && loading" />
            <div v-else>
                <div v-if="hasMore" class="flex justify-center">
                    <button
                        @click="showMore"
                        class="border flex justify-center items-center h-10 w-40 border-gray-400 hover:border-gray-800 text-sm rounded px-3 py-2"
                    >
                        <spinner v-if="loadingMore" class="text-white" />
                        <span v-else>{{ $t('Load More') }}</span>
                    </button>
                </div>
                <div v-else class="flex justify-center">
                    <span>{{ $t('No more items to show') }}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from 'lodash'
import GivCard from '../components/GivCard'
import api from '../lib/api'

const formatDateInput = d => {
    const result = d.toISOString().split('T')[0]
    return result
}

export default {
    components: {
        GivCard,
    },
    methods: {
        searchGivers: _.debounce(async function(search, loading) {
            if (!search || search === '') return
            loading(true)
            const users = await api.searchUsersByName(search)
            const makeList = list => {
                const res = []
                list.forEach(item => {
                    res.push({
                        label: item.name,
                        id: item.id,
                    })
                })
                return res
            }
            this.searchGiversList = makeList(users)
            loading(false)
        }, 1000),
        searchReceivers: _.debounce(async function(search, loading) {
            if (!search || search === '') return
            loading(true)
            const users = await api.searchUsersByName(search)
            const makeList = list => {
                const res = []
                list.forEach(item => {
                    res.push({
                        label: item.name,
                        id: item.id,
                    })
                })
                return res
            }
            this.searchReceiversList = makeList(users)
            loading(false)
        }, 1000),
        async showMore() {
            this.loadingMore = true
            const [moreGivs, newOffset] = await api.getGivs(
                this.limit,
                this.offset,
                this.filteredMember,
            )
            this.givs = [...this.givs, ...moreGivs]
            this.offset = newOffset
            this.loadingMore = false
            if (!moreGivs.length) {
                this.hasMore = false
            }
        },

        async createGiv() {
            this.submitting = true
            this.formError = null
            const payload = {
                giverId: this.formGivGiver.id,
                receiverId: this.formGivReceiver.id,
                type: this.formGivType,
                status: 'finished',
            }
            await api.createGiv(payload)
            this.submitting = false
            this.submitted = true
        },
        closeModal() {
            this.formError = null
            this.open = false
            if (this.submitted) {
                this.$router.go()
            }
        },
        resetData() {
            this.formGivType = 'meetup'
            this.formGivGiver = null
            this.formGivReceiver = null
            this.formGivDate = formatDateInput(new Date())
        },
        async setSelected(value) {
            this.filteredMember = value
            this.loading = true
            const [givs, newOffset] = await api.getGivs(this.limit, null, this.filteredMember)
            this.givs = givs
            this.offset = newOffset
            this.hasMore = true
            this.loading = false
        },
        search: _.debounce(async function(search, loading) {
            if (!search || search === '') return
            loading(true)
            const result = await api.searchUsersByName(search)
            const makeList = list => {
                return list.map(item => {
                    return {
                        ...item,
                        label: item.name,
                        id: item.id,
                    }
                })
            }
            this.filterMemberList = makeList(result)
            loading(false)
        }, 500),
        parseUrl(url) {
            if (!url) return url
            if (url.startsWith('http')) {
                return url
            }
            return `https://cdn.giv.link/${url}`
        },
    },
    computed: {
        formValid() {
            return (
                !!this.formGivGiver &&
                this.formGivGiver !== '' &&
                !!this.formGivReceiver &&
                this.formGivReceiver !== '' &&
                !!this.formGivDate &&
                this.formGivDate !== '' &&
                !!this.formGivType &&
                this.formGivType !== ''
            )
        },
    },
    data() {
        return {
            givs: null,
            loading: true,
            searchGiversList: [],
            searchReceiversList: [],
            formError: null,
            formGivType: 'mail',
            formGivGiver: null,
            formGivReceiver: null,
            formGivDate: formatDateInput(new Date()),
            submitting: false,
            submitted: false,
            loadingMore: false,
            open: false,
            limit: 10,
            offset: null,
            hasMore: true,
            filterMemberList: [],
            filteredMember: null,
        }
    },
    async mounted() {
        if (this.$route.query.reload === true) {
            /* this.$apollo.queries.givs.refetch() */
            this.$router.push('/givs')
        }
        const [givs, newOffset] = await api.getGivs(this.limit, null)
        this.givs = givs
        this.offset = newOffset
        this.hasMore = true
        this.loading = false
    },
}
</script>
<style>
.style-select .vs__dropdown-toggle {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #ffffff;
    border-color: #d2d6dc;
    border-width: 1px;
    border-radius: 0.375rem;
    padding-top: 0.4rem;
    padding-right: 0.55rem;
    padding-bottom: 0.5rem;
    padding-left: 0.55rem;
    font-size: 1rem;
    line-height: 1.5;
}
</style>
